/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

/**
 * @module ItemsModule
 */

import { UpdatableBase } from 'ajs/modules/data-model/factories/updatable-base.factory';

/**
 * @description License usage information for summary table.
 * @author Akul Aggarwal, alextsg
 */
export class LicenseUsage extends UpdatableBase {
    // Needed for ListDataTransport, since UpdatableBase does not set objectName_ based on
    // constructor arguments.
    public objectName_: string;

    public config: Record<string, any>;

    constructor(args = {}) {
        const extendedArgs = {
            defaultDataSources: 'list',
            isStatic: true,
            allDataSources: {
                list: {
                    source: 'LicenseUsageDataSource',
                    transformer: 'LicenseUsageDataTransformer',
                    transport: 'ListDataTransport',
                    fields: ['config'],
                },
            },
            ...args,
        };

        super(extendedArgs);

        this.objectName_ = 'licenseusage';
    }
}
